export const DIRECTION_TOP = 1
export const DIRECTION_BOTTOM = 2